'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "InputComponent"];
import FilterOperatorValueInput from './FilterOperatorValueInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { memo } from 'react';
import FilterOperatorDateRangeInput from './FilterOperatorDateRangeInput';
import FilterOperatorDateRangeInputMoment from './FilterOperatorDateRangeInputMoment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorHighValueInput = props => {
  const {
      className,
      InputComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (InputComponent === FilterOperatorDateRangeInput) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInput, Object.assign({}, props));
  }
  if (InputComponent === FilterOperatorDateRangeInputMoment) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInputMoment, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(FilterOperatorValueInput, Object.assign({
      InputComponent: InputComponent,
      className: "m-bottom-1",
      fieldName: "value"
    }, rest)), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterOperatorInput.rangeAnd"
    }), /*#__PURE__*/_jsx(FilterOperatorValueInput, Object.assign({
      InputComponent: InputComponent,
      className: "m-top-1",
      fieldName: "highValue"
    }, rest))]
  });
};
FilterOperatorHighValueInput.propTypes = {
  InputComponent: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default /*#__PURE__*/memo(FilterOperatorHighValueInput);